import React from 'react'
import Pt from 'prop-types'
import { ListGroupItem } from 'react-bootstrap'

import Icon from '../../Icon'

export default function NewToken({
  active,
  selectToken,
}) {
  return (
    <ListGroupItem
      active={active}
      onClick={() => selectToken(null)}
    >
      <h4>
        {active && <Icon name="check" />}
        New Card
      </h4>

      <p>Save a new credit card for this service.</p>
    </ListGroupItem>
  )
}

NewToken.propTypes = {
  active: Pt.bool.isRequired,
  selectToken: Pt.func.isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Payment/TokenSelector/NewToken.jsx